import {
    Stack,
    Heading,
    Text,
    Button,
    useDisclosure,
    Drawer,
    DrawerBody,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton
} from '@chakra-ui/react'
import useParentRegistration from '../hooks/useParentRegistration'
import CoParentRegistrationForm from './CoParentRegistrationForm'

export default function AddCoParentDrawer({ parentId }: { parentId: string }) {
    
    const { isOpen, onOpen, onClose } = useDisclosure()
    const { handleSubmit, register, errors, control, isSubmitting } =
        useParentRegistration(onClose, parentId)

    const onSubmit = async () => {
        await handleSubmit()
    }

    return (
        <>
            <Button colorScheme="brand" size={'lg'} onClick={onOpen}>
                Add Spouse
            </Button>
            <Drawer 
            isOpen={isOpen} 
            placement="right" 
            onClose={onClose} 
            size={'md'}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerBody>
                        <Stack textAlign={'center'} mt={8} mb={16}>
                            <Heading fontSize={'2xl'}>Add spouse</Heading>
                            <Text fontSize={{ base: 'sm', sm: 'md' }} color={'gray.600'}>
                                Provide your spouse information to add as Co-parent
                            </Text>
                        </Stack>

                        <CoParentRegistrationForm
                            onSubmit={onSubmit}
                            register={register}
                            errors={errors}
                            control={control}
                            isSubmitting={isSubmitting}
                        />
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    )
}
